"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["className", "theme", "name", "placeholder", "testId", "tabindex", "autocomplete", "autoFocus", "isValid", "isDirty", "isFocused", "isPending", "value", "onKeyDown", "onFocus", "onBlur", "onChange", "validate", "validateOn", "size"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  disabled: false,
  autoFocus: false,
  isDirty: false,
  onChange: function onChange() {},
  onKeyDown: function onKeyDown() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  theme: {}
};

/**
 * Provides a decorated textarea element.
 */
var TextArea = exports["default"] = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TextArea, _Component);
  /* istanbul ignore next */
  function TextArea(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TextArea);
    _this = _callSuper(this, TextArea, [props]);
    var _this$props = _this.props,
      autoFocus = _this$props.autoFocus,
      value = _this$props.value;
    _this.state = {
      autoFocusState: autoFocus,
      value: value
    };
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleInputChange = _this.handleInputChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleInputFocus = _this.handleInputFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleInputBlur = _this.handleInputBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  // eslint-disable-next-line camelcase
  (0, _createClass2["default"])(TextArea, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.state.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e, type) {
      var disabled = this.props.disabled;
      var handler = this.props[type];
      if (disabled) {
        return false;
      }
      return handler(e);
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(e) {
      var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        onChange = _this$props2.onChange;
      if (disabled) {
        return false;
      }
      var stateDiff = {
        value: e.currentTarget.value
      };
      return this.setState(stateDiff, function () {
        return onChange(stateDiff);
      });
    }
  }, {
    key: "handleInputFocus",
    value: function handleInputFocus(e) {
      this.setState({
        autoFocusState: true
      });
      return this.handleEvent(e, 'onFocus');
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur(e) {
      this.setState({
        autoFocusState: false
      });
      return this.handleEvent(e, 'onBlur');
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      return this.handleEvent(e, 'onKeyDown');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        className = _this$props3.className,
        theme = _this$props3.theme,
        name = _this$props3.name,
        placeholder = _this$props3.placeholder,
        testId = _this$props3.testId,
        tabindex = _this$props3.tabindex,
        autocomplete = _this$props3.autocomplete,
        autoFocus = _this$props3.autoFocus,
        isValid = _this$props3.isValid,
        isDirty = _this$props3.isDirty,
        isFocused = _this$props3.isFocused,
        isPending = _this$props3.isPending,
        value = _this$props3.value,
        onKeyDown = _this$props3.onKeyDown,
        onFocus = _this$props3.onFocus,
        onBlur = _this$props3.onBlur,
        onChange = _this$props3.onChange,
        validate = _this$props3.validate,
        validateOn = _this$props3.validateOn,
        size = _this$props3.size,
        props = (0, _objectWithoutProperties2["default"])(_this$props3, _excluded);
      var valueToUse = this.state.value;
      var tabIndexValue = tabindex || '';
      var isFocusedStatus;
      switch (isFocused) {
        case true:
          isFocusedStatus = isFocused;
          break;
        case false:
          isFocusedStatus = isFocused;
          break;
        default:
          isFocusedStatus = this.state.autoFocusState;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-test-id": testId,
        "data-anypoint-component": TextArea.displayName,
        className: (0, _classnames["default"])(theme.textarea, isDirty ? theme['is-dirty'] : '', isValid ? theme['is-valid'] : '', isValid === false ? theme['has-error'] : '', isFocusedStatus ? theme['is-focused'] : '', className, size ? theme["form-size-".concat(size)] : '')
      }, /*#__PURE__*/_react["default"].createElement("textarea", (0, _extends2["default"])({
        "data-test-id": testId && "".concat(testId, "-textarea"),
        value: valueToUse,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        placeholder: placeholder,
        name: name,
        tabIndex: tabIndexValue,
        autoComplete: autocomplete,
        autoFocus: autoFocus
      }, props)));
    }
  }]);
  return TextArea;
}(_react.Component);
(0, _defineProperty2["default"])(TextArea, "displayName", 'TextArea');
(0, _defineProperty2["default"])(TextArea, "defaultProps", defaultProps);
//# sourceMappingURL=TextArea.js.map